"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBox = void 0;
var React = require("react");
var __1 = require("../../");
var Theme_1 = require("../../Theme");
var NotificationBox_styles_1 = require("./NotificationBox.styles");
var NotificationBox = /** @class */ (function (_super) {
    __extends(NotificationBox, _super);
    function NotificationBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationBox.prototype.render = function () {
        // background colors of the container
        var bgColors = {
            Bold: {
                Error: Theme_1.Color.Red.R60,
                Info: Theme_1.Color.Grey.G80,
                Standard: "#FFFFFF",
                Success: Theme_1.Color.Green.G80,
                Warning: Theme_1.Color.Yellow.Y60,
            },
            Regular: {
                Error: Theme_1.Color.Red.R20,
                Info: Theme_1.Color.Grey.G30,
                Standard: "#FFFFFF",
                Success: Theme_1.Color.Green.G20,
                Warning: Theme_1.Color.Yellow.Y40,
            },
        };
        // text colors of the notification text
        var textColors = {
            Bold: {
                Error: "white",
                Info: "white",
                Standard: "black",
                Success: "white",
                Warning: "black",
            },
            Regular: {
                Error: "black",
                Info: "black",
                Standard: "black",
                Success: "black",
                Warning: "black",
            },
        };
        // colors of the icon
        var iconColors = {
            Bold: {
                Error: "white",
                Info: "white",
                Standard: "black",
                Success: "white",
                Warning: "black",
            },
            Regular: {
                Error: Theme_1.Color.Red.R60,
                Info: Theme_1.Color.Blue.B60,
                Standard: "black",
                Success: Theme_1.Color.Green.G60,
                Warning: Theme_1.Color.Yellow.Y80,
            },
        };
        var defaultIcons = {
            Error: __1.Icons.AlertTriangle,
            Info: __1.Icons.Info,
            Standard: __1.Icons.Home,
            Success: __1.Icons.TickCircle,
            Warning: __1.Icons.Alert,
        };
        // set additional styling of the LabelContainer here
        var containerStyle = {
            backgroundColor: bgColors[this.props.Variant][this.props.NotificationType],
            color: textColors[this.props.Variant][this.props.NotificationType],
        };
        var iconStyle = {
            color: iconColors[this.props.Variant][this.props.NotificationType],
        };
        // check if icon is enabled, if it is display it
        var NotificationIcon = this.props.EnableIcon ? (React.createElement(NotificationBox_styles_1.IconContainerDiv, { style: iconStyle },
            React.createElement(__1.Icon, { Icon: this.props.CustomIcon ? this.props.CustomIcon : defaultIcons[this.props.NotificationType], Height: "32px", Width: "32px" }))) : null;
        var AriaLabel = this.props.NotificationType + " Notification - " + this.props.Caption;
        return (React.createElement(NotificationBox_styles_1.NotificationContainerDiv, { style: containerStyle },
            NotificationIcon,
            React.createElement(NotificationBox_styles_1.TitleH3, { tabIndex: this.props.TabIndex ? this.props.TabIndex : 0, "aria-label": AriaLabel }, this.props.Caption),
            React.createElement(NotificationBox_styles_1.SubTitleSpan, { tabIndex: this.props.TabIndex ? this.props.TabIndex : 0, "aria-label": AriaLabel }, this.props.SubTitle)));
    };
    NotificationBox.defaultProps = {
        Variant: "Regular",
    };
    return NotificationBox;
}(React.PureComponent));
exports.NotificationBox = NotificationBox;
